import { render, staticRenderFns } from "./CustomVideo.vue?vue&type=template&id=1996ac0d&"
import script from "./CustomVideo.vue?vue&type=script&lang=js&"
export * from "./CustomVideo.vue?vue&type=script&lang=js&"
import style0 from "./CustomVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports